import { getGlobalProperty } from "@faire/web--source/common/globals/getGlobalProperty";
import { envName } from "@faire/web--source/common/user-agent/envName";
var getServerHost = function() {
    var serverHost = getGlobalProperty("switchboardUrl", defaultServerHost());
    return serverHost;
};
var defaultServerHost = function() {
    switch(envName()){
        case "production":
            return "wss://www.faire.com:443";
        case "prerelease":
            return "wss://www.prerelease.faire.dev";
        case "sandbox":
            {
                var sandboxUrl = _getSandboxUrl();
                return sandboxUrl;
            }
        case "staging":
        default:
            return "wss://www.faire-stage.com";
    }
};
export var webSocketUrls = {
    faireGeneral: function() {
        return "".concat(getServerHost(), "/web-socket");
    },
    retailerNotification: function() {
        return "".concat(getServerHost(), "/retailer-notification-web-socket");
    }
};
export var convertToSwitchBoardUrl = function(url) {
    return url.replace("wss://www.", "wss://switchboard.");
};
var _getSandboxUrl = function() {
    var backendInternalUrl = getGlobalProperty("backendUrl", "");
    var re = /e2e(-fe|-e2e|-common)?(-\d+){1,2}\.sandbox(\.oci)?\.faire\.team/; // e2e-fe-58102, e2e-fe-2-24971, e2e-e2e-41313, e2e-5-10471, e2e-common-21290
    var backendUrl = backendInternalUrl.match(re);
    if (!backendUrl) {
        return "wss://backend-web";
    }
    return "wss://".concat(backendUrl[0]);
};
